import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { Card } from '@/components/ui/Card';

export default function Unauthorized() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas p-6">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="w-12 h-12 rounded-full bg-danger/10 flex items-center justify-center text-danger mx-auto mb-4">
          <ShieldOff size={24} />
        </div>
        <h1 className="text-section font-display font-semibold text-ink">Akses ditolak</h1>
        <p className="text-body text-ink-subtle mt-2">
          Role kamu tidak punya akses ke halaman ini.
        </p>
        <Link
          to="/dashboard"
          className="inline-block mt-6 text-primary hover:underline text-body font-medium"
        >
          Kembali ke dashboard
        </Link>
      </Card>
    </div>
  );
}
